<template>
  <div class="cw-collapse">
    <div class="header">
      <slot name="header">
        <div class="img-list"><img :src="listUrl" width="100%"/></div>
        {{title}}
      </slot>
      <div class="show-more" @click="handleShowMore">
        <div class="arrow-text">
          <span :class="showMore ? 'arrow-up' : 'arrow-down'"></span>
          <p>{{showMore ? collapseText[1] : collapseText[0]}}</p>
        </div>
      </div>
    </div>
    <div class="content" v-show="showMore">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import listUrl from '@assets/images/list.png';

  export default {
    name: 'CwCollapse',

    componentName: 'CwCollapse',

    props: {
      text: {
        type: [String, Array],
        'default': function () {
          return ['更多筛选', '收起筛选'];
        }
      },
      'default-open': {
        type: Boolean,
        default: false
      },
      'slot-header': ''
    },
    methods: {
      handleShowMore () {
        this.showMore = !this.showMore;
        if (this.showMore) {
          this.$emit('showMore');
          if (_hmt) {
            _hmt.push(['_trackEvent', location.hash.substring(1), '展开查询条件']);
          }
        }
      }
    },
    computed: {
      collapseText () {
        if (typeof this.$props.text === 'string') {
          let matchArr = this.$props.text.match(/(.*)[,|，|、| ](.*)/);
          if (matchArr) {
            return [matchArr[1], matchArr[2]];
          } else {
            return [this.$props.text, this.$props.text];
          }
        } else {
          return this.$props.text;
        }
      },
    },
    data () {
      return {
        showMore: this.$props.defaultOpen || false,
        title: this.$props.slotHeader,
        listUrl
      };
    }
  };
</script>
<style lang="less">
  @normal-border: #d8d8d8;
  .cw-collapse {
    .header {
      position: relative;
      min-height: 36px;
    }
    .img-list {
      display: inline-block;
      width: 28px;
    }
    .show-more .arrow-text {
      position: absolute;
      top: 0;
      right: 30px;
      z-index: 1;
      padding: 8px 30px;
      cursor: pointer;
      user-select: none;
      color: #016CDF;
    }

    .arrow-up:before {
      content: '';
      position: absolute;
      transform: rotate(-45deg);
      top: 50%;
      left: 13px;
      width: 6px;
      height: 6px;
      border-top: 1px solid #016CDF;
      border-right: 1px solid #016CDF;
    }
    .arrow-down:before {
      content: '';
      position: absolute;
      transform: translateY(-50%) rotate(135deg);
      top: 50%;
      left: 13px;
      width: 6px;
      height: 6px;
      border-top: 1px solid #016CDF;
      border-right: 1px solid #016CDF;
    }
  }
</style>



// WEBPACK FOOTER //
// Collapse.vue?37a5b344